import React, { Component, Fragment } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import { Button, Form, FormGroup, Label, Input, FormText, Badge } from 'reactstrap';
import { BrandUniversityAddEdit } from './BrandUniversityAddEdit';
import { SidePanel } from '../../common/SidePanel';
import { findObjectIndexInArray } from '../../utils/ArrayUtil';
import { TransitionComponents } from '../../common/TransitionComponents';
import { isNumber } from '../../utils/Validation';

export class BrandUniversities extends Component {
    static displayName = BrandUniversities.name;

    constructor(props) {
        super(props);
        this.state = {
            designerId: props.designerId,
            data: props.data.universities || [],
            loading: true,
            error: null,
            editObject: null,
            showSlide: false
        };

        this.populateUniversityList = this.populateUniversityList.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setError = this.setError.bind(this);
        this.showAddEditSlide = this.showAddEditSlide.bind(this);
        this.onSlideExited = this.onSlideExited.bind(this);
        this.updateData = this.updateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    }

    componentDidMount() {
        this.populateUniversityList();
    }

    componentWillReceiveProps(props) {
        //this.setState({ data: props.data })
    }

    setError(error) {
        this.props.setError(error);
        this.setState({ loading: false });
    }

    handleInputChange(event) {
        //console.log(event.target);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: value
            }
        }));
    }

    showAddEditSlide(index) {
        //console.log('id: ' + index);
        this.setState({
            showSlide: true,
            editObject: isNumber(index) && index >= 0 ? {
                ...this.state.data[index],
                index: index
            } : null
        });
    }

    onSlideExited() {
        this.setState({
            showSlide: false,
            editObject: null
        });
    }

    updateData(obj) {
        console.log('saving:')
        console.log(obj)
        if (!obj) return;

        const uniName = this.state.universityList[findObjectIndexInArray(this.state.universityList, obj.universityId, 'universityId')].name;
        obj.universityName = uniName;

        if (isNumber(obj.index) && obj.index >= 0 && this.state.data.length > obj.index) {
            //edit
            this.setState({
                data: this.state.data.map((item, index) => {
                    if (obj.index === index) {
                        item.universityId = obj.universityId;
                        item.universityName = obj.universityName;
                        item.courseTitle = obj.courseTitle;
                        item.graduationYear = obj.graduationYear;
                    }
                    return item;
                })
            });
        } else {
            //add
            this.setState({
                data: [
                    ...this.state.data,
                    obj
                ]
            });
        }
    }

    deleteData(index) {
        if (isNumber(index) && index >= 0 && this.state.data.length > index) {
            console.log('deleting: ' + index);
            const arr = this.state.data;
            arr.splice(index, 1);
            this.setState({
                data: arr
            });
        }
    }


    render() {
        const { designerId, data, loading, editObject, showSlide } = this.state;

        /*
        if (this.state.loading)
            return (
                <div className="bg-white rounded box-shadow p-4 mb-4">
                    <div className="mb-1">University</div>
                    <FormText color="muted" className="text-left mb-3">
                        List of universities the designers behind the brand graduated from
                    </FormText>

                    <div className="d-flex justify-content-center">
                        <div className="spinner-border my-5" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>);
                */

        let universityItems = this.state.data.map((item, index) => {
            return (
                <tr key={index}>
                    <th scope="row">{item.universityName}</th>
                    <td>{item.courseTitle}</td>
                    <td className="text-center">{item.graduationYear}</td>
                    <td className="d-flex flex-row justify-content-end">
                        <button type="button" className="btn btn-default btn-sm py-0 px-1 d-flex align-items-center" aria-label="Edit"
                            onClick={() => {
                                this.showAddEditSlide(index);
                            }}>
                            <svg height="16" viewBox="0 0 48 48" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M6 34.5v7.5h7.5l22.13-22.13-7.5-7.5-22.13 22.13zm35.41-20.41c.78-.78.78-2.05 0-2.83l-4.67-4.67c-.78-.78-2.05-.78-2.83 0l-3.66 3.66 7.5 7.5 3.66-3.66z" /><path d="M0 0h48v48h-48z" fill="none" /></svg>
                        </button>
                        <button type="button" className="btn btn-default btn-sm py-0 px-1 d-flex align-items-center" aria-label="Delete"
                            onClick={() => {
                                this.deleteData(index);
                            }}>
                            <svg height="16" viewBox="0 0 48 48" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M12 38c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-24h-24v24zm26-30h-7l-2-2h-10l-2 2h-7v4h28v-4z" /><path d="M0 0h48v48h-48z" fill="none" /></svg>
                        </button>
                    </td>
                </tr>
            );
        });

        //console.log(showSlide);
        return (
            <div>
                <h3>University</h3>
                <div className="bg-white rounded box-shadow p-4 mb-4">
                    <div className="mb-1">University list</div>
                    <FormText color="muted" className="text-left mb-3">
                        List of universities the designer(s) behind the brand graduated from
                    </FormText>

                    <Button color="dark" size="sm" className="mb-3" disabled={loading} onClick={() => this.showAddEditSlide()}>Add new university</Button>

                    <div className="table-responsive">
                        <table className="table table-hover table-sm table-borderless table-striped">
                            <caption>List of universities</caption>
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">University</th>
                                    <th scope="col">Course</th>
                                    <th className="text-center" scope="col">Graduation Year</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {universityItems}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-4 mb-5 formbox-savebtn">
                        <div className="row">
                            <div className="col-7"></div>
                            <div className="col-5 text-right">
                                <Button color="dark" size="sm" disabled={loading} onClick={() => this.handleSubmit()}>{!loading ? 'Save changes' : 'Loading..'}</Button>
                            </div>
                        </div>
                    </div>

                    <TransitionComponents className="slideanim"
                        show={loading === false && showSlide}>
                        <BrandUniversityAddEdit
                            designerId={designerId}
                            data={editObject}
                            onExited={this.onSlideExited}
                            universityList={this.state.universityList}
                            update={this.updateData}
                            />
                    </TransitionComponents>
                </div>
            </div>
        );
    }

    async handleSubmit() {
        this.setState({ loading: true });

        console.log('submitting..');
        console.log(this.state);

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const reqHeader = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization': `Bearer ${token}`
        };

        const { data } = this.state;

        const response = await fetch(`/api/brand/details/${this.state.designerId}/edit/universities`, {
            method: 'post',
            headers: reqHeader,
            body: JSON.stringify(data)
        });


        try {
            const newDta = await response.json();

            if (newDta && newDta.result) {
                //added
                console.log('Brand submitted');
                console.log(newDta);

                this.setState({ data: newDta.brand.universities, loading: false });

                //this.props.scrollPageToTop();
                this.props.updateData(function () {
                    //update button state
                });
            } else {
                this.setError(`Error`);
            }
        } catch (e) {
            this.setError(`Error`);
            console.log(e);
        }
    }

    async populateUniversityList() {
        const token = await authService.getAccessToken();
        const response = await fetch('/api/universities/all/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        console.log(data);
        this.setState({
            universityList: data,
            loading: false
        });
    }

}
